import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface PayrollTypeEditorFooterProps {
  onSave: () => void;
  onDelete: () => void;
  isPending: boolean;
  can_update: boolean;
  can_delete: boolean;
}

const PayrollTypeEditorFooter = ({
  onSave,
  onDelete,
  isPending,
  can_update,
  can_delete,
}: PayrollTypeEditorFooterProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-between gap-4">
      <Button
        variant="destructive"
        onClick={onDelete}
        disabled={isPending || !can_delete}
      >
        <Trash2 className="w-4 h-4 mr-2" />
        {t("payrollTypes.deleteButton")}
      </Button>
      <Button onClick={onSave} disabled={isPending || !can_update}>
        {t("payrollTypes.save")}
      </Button>
    </div>
  );
};

export default PayrollTypeEditorFooter;
